export class ActivityReviewTypeConstants {
  public static readonly REVIEW = "Review";

  public static readonly ASSESSMENT = "Assessment";
}
